<div class="main-content">
  <div class="header-actions">
    <h4 class="card-title">Category List</h4>
    <div style="display: flex; gap: 8px; align-items: center;">
      <fh-refresh-button [refresh]="refreshData" />
      <button mat-raised-button color="primary" (click)="addCategory()">
        <mat-icon>add</mat-icon>
        Add Category
      </button>
    </div>
  </div>

  @if (success_msg()) {
    <div class="alert alert-green">
      <span>{{ success_msg() }}</span>
    </div>
  }

  <div class="filters-container">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search Categories</mat-label>
      <input
        matInput
        [(ngModel)]="searchTerm"
        (keyup.enter)="onSearch()"
        placeholder="Search by category name"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="statusFilter" (selectionChange)="onStatusFilterChange()">
        <mat-option value="">All</mat-option>
        <mat-option value="active">Active</mat-option>
        <mat-option value="inactive">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="accent" (click)="onSearch()">
      <mat-icon>search</mat-icon>
      Search
    </button>
  </div>

  <fh-data-table
    [config]="tableConfig()"
    [sortProp]="sortProp()"
    [sortDir]="sortDir()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [actions]="tableActions()"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  />
</div>
